import { render, staticRenderFns } from "./HolderInfo.vue?vue&type=template&id=05623d38&scoped=true&"
import script from "./HolderInfo.vue?vue&type=script&lang=js&"
export * from "./HolderInfo.vue?vue&type=script&lang=js&"
import style0 from "./HolderInfo.vue?vue&type=style&index=0&id=05623d38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05623d38",
  null
  
)

export default component.exports